import { useContext } from "react";
import { DataTableQueryContext } from "../DataTableQueryContext";
import { DataTableQuery } from "@/types/dataTableQuery";

export const useDataTableQuery = <Q,>() =>
  useContext(DataTableQueryContext as React.Context<DataTableQuery<Q>>);
